import { ProductSource } from "../models/ProductSource";

export function getAutocompleteTypeFromProductSource(source: number | string): string {
  const val = Number(source);
  switch (val) {
    case ProductSource.Navision:
      return 'navisionproduct';
    case ProductSource.Delta:
      return 'deltaproduct';
    case ProductSource.Xledger:
      return 'xledgerproduct';
    case ProductSource.BCVoninRefa:
      return 'bcvoninrefaproduct';
    case ProductSource.BCFaroeIslands:
      return 'bcfaroeislandsproduct';
    default:
      return 'generalproduct';
  }
}